export enum Colors
{
  primary = 'primary',
  accent = 'accent',
  warn = 'warn'
}
